import React, { useState, useEffect } from "react";
import TomedesLogo from "assets/images/Tomedes_Logo.svg";
import { Link } from "gatsby";
import { Services, Languages, AboutData, Industries, Services2 } from "./config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faUser, faTimes} from "@fortawesome/free-solid-svg-icons";
// import { INDUSTRIES } from "../footer/FooterData";
import usaSvg from "../../../assets/images/usa.svg";

export default function Header() {
  const [hamburger, setHamburger] = useState(false);
  const [serviceMenu, setServiceMenu] = useState(false);
  const [languagesMenu, setLanguagesMenu] = useState(false);
  const [aboutMenu, setAboutMenu] = useState(false);
  const [industriesMenu, setIndustries] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const listenToScroll = () => {
    let heightToHideFrom = 60;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

    if (winScroll > heightToHideFrom) {
      isVisible && setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  const style = {
    background: "transparent linear-gradient(180deg, #000000 0%, #00173A 100%) 0% 0% no-repeat padding-box",
  };
  const removeShadow = {
    "-webkit-tap-highlight-color": "transparent",
  };

  const caretDownFil = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
    </svg>
  );

  const closeModalIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );

  return (
    <>
      <div className=" items-center justify-center w-full border-b border-quotetext-300 hidden lg:flex bg-black">
        <div className="max-w-screen-xl py-2 w-full flex items-center justify-end">
          <div className="flex items-center justify-evenly"></div>
          <p className="flex flex-wrap font-opensans font-normal mr-8 text-[13px] leading-[20px] text-[#A5A5A5]">
            <a href="mailto:support@tomedes.com">support@tomedes.com</a>
            <span>&nbsp;|&nbsp;</span>
            <a href="tel:+19852390142">US: +1 985 239 0142</a>
            <span>&nbsp;|&nbsp;</span>
            <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
          </p>
          <Link to="/user/login" className="font-normal text-[13px] font-opensans ml-3 mr-2 text-white flex  items-center justify-center">
            <p className="font-normal text-[13px] font-opensans ml-3 mr-2 text-white flex  items-center justify-center">
              <FontAwesomeIcon icon={faUser} className="mr-2 text-white w-[10px]" />
              ACCOUNT
            </p>
          </Link>
          <div>
            <p className="ml-2 font-secondary text-[14px] text-gray hover:text-orange flex justify-center items-center gap-2 relative group cursor-pointer">
              <img src={usaSvg} alt="" /> <span>USA - EN</span> <span>{caretDownFil}</span>
              <div className="absolute  top-0 z-[101] pt-[29px] hidden group-hover:block">
                <div className="usa_modal_body bg-white  pl-6 py-2 space-y-3  w-[234px] h-[250px] overflow-y-scroll ">
                  <div>
                    <a hreflang="en-us" href="https://www.tomedes.com/" className="text-black hover:text-lightBlue">
                      English
                    </a>
                  </div>

                  <div>
                    <a hreflang="es" href="https://es.tomedes.com/" className="text-black hover:text-lightBlue">
                      Español
                    </a>
                  </div>

                  <div>
                    <a hreflang="cn" href="https://cn.tomedes.com/" className="text-black hover:text-lightBlue">
                      简体中文
                    </a>
                  </div>

                  <div>
                    <a hreflang="cn" href="https://tw.tomedes.com/" className="text-black hover:text-lightBlue">
                      中國傳統的
                    </a>
                  </div>

                  <div>
                    <a hreflang="de" href="https://de.tomedes.com/" className="text-black hover:text-lightBlue">
                      Deutsch
                    </a>
                  </div>
                  <div>
                    <a hreflang="fr" href="https://fr.tomedes.com/" className="text-black hover:text-lightBlue">
                      Français
                    </a>
                  </div>

                  <div>
                    <a hreflang="nl" href="https://nl.tomedes.com/" className="text-black hover:text-lightBlue">
                      Nederlands
                    </a>
                  </div>

                  <div>
                    <a hreflang="he" href="https://www.tomedes.co.il/" className="text-black hover:text-lightBlue">
                      עברית
                    </a>
                  </div>

                  <div>
                    <a hreflang="ja" href="https://jp.tomedes.com" className="text-black hover:text-lightBlue">
                      日本語
                    </a>
                  </div>

                  <div>
                    <a hreflang="ko" href="https://kr.tomedes.com/" className="text-black hover:text-lightBlue">
                      한국어
                    </a>
                  </div>

                  <div>
                    <a hreflang="nb" href="https://no.tomedes.com/" className="text-black hover:text-lightBlue">
                      Norsk
                    </a>
                  </div>

                  <div>
                    <a hreflang="pl" href="https://pl.tomedes.com/" className="text-black hover:text-lightBlue">
                      Polski
                    </a>
                  </div>

                  <div>
                    <a hreflang="ro" href="https://ro.tomedes.com/" className="text-black hover:text-lightBlue">
                      Româna
                    </a>
                  </div>

                  <div>
                    <a hreflang="sv" href="https://sv.tomedes.com/" className="text-black hover:text-lightBlue">
                      Svenska
                    </a>
                  </div>

                  <div>
                    <a hreflang="tr" href="https://tr.tomedes.com/" className="text-black hover:text-lightBlue">
                      Türk
                    </a>
                  </div>

                  <div>
                    <a hreflang="ru" href="https://ru.tomedes.com/" className="text-black hover:text-lightBlue">
                      Русский
                    </a>
                  </div>
                </div>
              </div>
            </p>
          </div>
        </div>
      </div>
      <section className="header-wrapper sticky top-[-1px] left-0 right-0 z-[100] bg-black flex flex-col items-center justify-center px-4">
        <div className="flex items-center justify-between lg:flex-row flex-col py-5 sm:py-6 sm:p-6 lg:p-0  max-w-screen-xl w-full">
          <div className="logo flex justify-between items-center w-full text-left">
            <Link to="/" className=" hidden sm:block">
              <img src={TomedesLogo} alt="loading..." className="w-[150px] md:w-[unset]" />
            </Link>
            {isVisible && (
              <Link to="/" className="sm:hidden">
                <img src={TomedesLogo} alt="loading..." className="w-[150px] md:w-[unset] h-8" />
              </Link>
            )}
            {!isVisible && (
              <Link
                to="/quote"
                className="uppercase rounded-full bg-orange hover:bg-[#ff9a16] text-white cursor-pointer text-14 font-semibold py-1 px-4 text-center transition-all duration-300 sm:hidden h-8 flex items-center"
              >
                Translate Now
              </Link>
            )}
            {hamburger ? (
              <div className="w-8 lg:hidden h-8 bg-white text-black text-center flex items-center justify-center text-xl rounded-full" onClick={() => setHamburger(!hamburger)}>
                <FontAwesomeIcon icon={faTimes} className="" />
              </div>
            ) : (
              <div className="lg:hidden flex flex-col items-center justify-center" onClick={() => setHamburger(!hamburger)}>
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 my-1.5 rounded-lg bg-white"></span>
                <span className="inline-block h-1.5  w-10 rounded-lg bg-white"></span>
              </div>
            )}
          </div>
          <p className="flex lg:hidden p-3 pl-0 pb-0 flex-col flex-wrap font-opensans font-normal text-[12px] leading-[20px] text-[#A5A5A5] self-baseline mt-2">
            <a href="mailto:support@tomedes.com">support@tomedes.com</a>
            <div>
              <a href="tel:+19852390142">US: +1 985 239 0142</a>
              <span>&nbsp;|&nbsp;</span>
              <a href="tel:+441615096140">UK: +44 (0)16 1509 6140</a>
            </div>
          </p>
          <section className={`${hamburger ? "block" : "hidden"} w-full lg:block`}>
            <nav className="lg:flex items-center justify-center relative">
              <ul className="nav font-normal flex items-center font-opensans lg:flex-row flex-col  text-white" style={removeShadow}>
                  <li className="leading-[19px]">
                  <Link to="/" className="lg:px-6 lg:py-3 p-3 mx-1 text-[16px] hover:text-orange w-full cursor-pointer">
                      <span>Home</span>
                    </Link>
                  </li>

                <li className="service_menu focus:outline-none leading-[19px] lg:px-6 lg:py-10 p-3 mx-1 text-[16px] w-full inline-block cursor-pointer group relative">
                  <span className="flex justify-between items-center ">
                    <span>Services</span>
                    <FontAwesomeIcon
                      onClick={() => setServiceMenu(!serviceMenu)}
                      className={`transition duration-500 ${serviceMenu ? "rotate-180 text-orange" : ""} text-white lg:hidden text-2xl transition-all duration-300`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={`${
                      serviceMenu ? "block" : "hidden"
                    }  service_menu_child sm:w-[32rem] lg:absolute focus:outline-none left-0 lg:top-24 top-9  transition-all duration-500 pl-0 z-10 pt-5 pb-4 `}
                    style={style}
                  >
                    {Services?.map(({ list, link, byline }, index) => (
                      <Link to={link} key={index}>
                        <li className="px-[38px] sm:w-auto w-[20rem] pb-[15px] hover:text-orange text-left text-base font-secondary font-normal">
                          <div className={`${index == 1 || index == 0 ? "text-[16px] md:text-[20px] md:font-semibold" : " text-[16px] md:text-18px]"}`}>{list}</div>
                          <div className=" text-[12px] md:text-[13px] mt-2 text-newgray mb-4">{byline}</div>
                        </li>
                      </Link>
                    ))}
                    <div className="bg-[#001533] pt-[14px]">
                    {Services2?.map(({ list, link, byline }, index) => (
                      <Link to={link} key={index} >
                        <li className="px-[40px] w-auto sm:w-[20rem] hover:text-orange text-left text-base  font-secondary bg-[#001533] font-normal">
                          <div className={`${index == 1 || index == 0 ? "text-[16px] sm:text-[18px] py-[6px]" : " text-[18px] md:text-[18px]"}`}>{list}</div>
                          <div className=" text-[12px] md:text-[13px] mt-2 text-newgray mb-4">{byline}</div>
                        </li>
                      </Link>
                    ))}
                    </div>
                  </ul>
                </li>
                <li className="languages_menu leading-[19px] w-full lg:px-6 lg:py-10 p-3 mx-1 text-[16px] cursor-pointer group">
                  <span className="flex justify-between items-center">
                    Languages
                    {/* <span></span> */}

                    <FontAwesomeIcon
                      onClick={() => setLanguagesMenu(!languagesMenu)}
                      className={`${languagesMenu ? "rotate-180 text-orange" : ""} text-white lg:hidden text-2xl transition-all duration-300`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      languagesMenu ? "block" : "hidden"
                    } languages_menu_child w-full lg:w-6/12 left-[105px] top-24 place-content-center place-items-center z-10 grid-cols-1 lg:grid-cols-2 lg:absolute lg:py-4 py-8`}
                    style={style}
                  >
                    {Languages?.map(({ list, img_link, link, underline }, i) => (
                      <li key={i} className={`w-full ${ underline ? "underline": null}`}>
                          <Link to={link} className={`hover:text-orange text-lg font-normal font-opensans pr-4 pl-8 py-1 flex items-center `}>
                            {/* {!(index === (arr.length - 1)) &&
                            <img src={img_link} className="mr-2" alt="loading..." />
                            } */}
                            {img_link ? <img src={img_link} className="mr-2" alt="loading..." /> :"" }
                            {list && list}
                          </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="languages_menu leading-[19px] w-full lg:px-6 lg:py-10 p-3 mx-1 text-[16px] cursor-pointer group">
                  <span className="flex justify-between items-center">
                    <span>Industries</span>

                    <FontAwesomeIcon
                      onClick={() => setIndustries(!industriesMenu)}
                      className={`${industriesMenu ? "rotate-180 text-orange" : ""} text-white lg:hidden text-2xl transition-all duration-300`}
                      icon={faAngleDown}
                    />
                  </span>
                  <ul
                    className={` ${
                      industriesMenu ? "block" : "hidden"
                    } languages_menu_child w-full lg:w-5/12 left-24 top-24 place-content-center place-items-center z-10  lg:absolute lg:pb-[10px] pb-8 lg:ml-[150px]`}
                    style={style}
                  >
                    {Industries?.map(({ data, link }, index) => (
                      <Link className="w-full" to={link}>
                        <li key={index} className="hover:text-orange text-center text-lg font-normal font-opensans  py-1">
                          {data}
                        </li>
                      </Link>
                    ))}
                  </ul>
                </li>
                <li className="leading-[19px] lg:px-6 w-full lg:py-10 p-3 mx-1 text-[16px] cursor-pointer group">
                  <span className="flex justify-between items-center">
                    <span>About</span>
                    <FontAwesomeIcon
                      onClick={() => setAboutMenu(!aboutMenu)}
                      className={`${aboutMenu ? "rotate-180 text-orange" : ""} text-white lg:hidden text-2xl transition-all duration-300`}
                      icon={faAngleDown}
                    />
                  </span>
                  <div
                    className={`${
                      aboutMenu ? "block" : "hidden"
                    } items-center justify-center top-24 p-10 pt-5 flex-col lg:absolute w-full  md:w-[32rem] left-0 md:left-[175px] lg:hidden lg:group-hover:flex z-10`}
                    style={style}
                  >
                    <h3 className="font-secondary font-light text-[16px] text-white leading-[32px]">
                      We are a <span className="text-orange cursor-pointer">translation agency</span> committed to providing high-quality professional translation services to businesses and
                      individuals in the United States and around the world.
                    </h3>
                    <Link to="/about-tomedes" className="inline-block underline text-white hover:text-orange text-base font-opensans font-normal w-full text-left leading-[22px] mt-6 mb-8 uppercase">
                      Who we are
                    </Link>
                    <ul className="text-lg font-normal font-opensans list-disc w-full text-left list-inside text-[#C9C9C9]">
                      {AboutData?.map(({ link, list }, index) => (
                        <li className="leading-[24px] py-1.5 hover:text-orange hover:underline" key={index}>
                          <Link to={link}>{list}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                <Link to="/contactus.php" className="w-full lg:px-6 md:py-3 p-3 ml-1 hover:text-orange mr-2 text-[16px] cursor-pointer whitespace-nowrap">
                  <li className="leading-[19px] ">
                    <span className="inline-block transition-all duration-300">Contact Us</span>
                  </li>
                </Link>
              </ul>
              <Link
                to="/quote"
                className="hidden lg:inline-block leading-[1] uppercase font-opensans font-bold text-center rounded-full py-3 bg-orange hover:bg-[#ff9a16] text-white text-sm cursor-pointer w-[153px] h-[40px]"
              >
                Translate Now
              </Link>
              <ul className="mt-10 lg:hidden flex flex-col gap-6 md:items-center">
                <li>
                  <Link
                    to="/quote"
                    className="block md:inline-block md:w-[450px]  uppercase rounded-full bg-orange hover:bg-[#ff9a16] font-opensans font-semibold text-gray cursor-pointer text-[14px] text-center py-5"
                  >
                    Translate Now
                  </Link>
                </li>
                <li>
                  <Link
                    to="/user/login"
                    className="block md:inline-block md:w-[450px]  uppercase rounded-full border-2 border-white font-opensans font-semibold text-gray cursor-pointer text-[14px] text-center py-5"
                  >
                    <FontAwesomeIcon icon={faUser} className="mr-2 text-white w-[10px]" />
                    Account
                  </Link>
                </li>
              </ul>
              <div className="block lg:hidden">
                <p className="mt-8 font-secondary text-[14px] text-gray flex justify-center items-center gap-2 cursor-pointer" onClick={() => setShowModal((showModal) => !showModal)}>
                  <img src={usaSvg} alt="" /> <span>USA - EN</span> <span>{caretDownFil}</span>
                </p>
              </div>
            </nav>
          </section>
        </div>
        {/* modal */}
        {showModal && (
          <div className="w-full h-full absolute z-[100] grid place-items-center bg-black opacity-[95%]">
            <div className="usa_modal h-[300px] w-[300px] overflow-scroll mt-[20%]">
              <div className="usa_modal_head bg-midBlue pl-6 pr-3 font-secondary text-[14px] text-gray flex justify-between items-center gap-2">
                <p className="flex items-center gap-4 cursor-pointer">
                  <img src={usaSvg} alt="" /> <span className="text-orange">USA - EN</span>
                </p>
                <span className="cursor-pointer" onClick={() => setShowModal((showModal) => !showModal)}>
                  {closeModalIcon}
                </span>
              </div>
              <div className="usa_modal_body bg-[#000D21] text-gray pl-6 py-2 space-y-3">
                <div>
                  <a hreflang="en-us" href="https://www.tomedes.com/">
                    English
                  </a>
                </div>

                <div>
                  <a hreflang="es" href="https://es.tomedes.com/">
                    Español
                  </a>
                </div>

                <div>
                  <a hreflang="cn" href="https://cn.tomedes.com/">
                    简体中文
                  </a>
                </div>

                <div>
                  <a hreflang="cn" href="https://tw.tomedes.com/">
                    中國傳統的
                  </a>
                </div>

                <div>
                  <a hreflang="de" href="https://de.tomedes.com/">
                    Deutsch
                  </a>
                </div>
                <div>
                  <a hreflang="fr" href="https://fr.tomedes.com/">
                    Français
                  </a>
                </div>

                <div>
                  <a hreflang="nl" href="https://nl.tomedes.com/">
                    Nederlands
                  </a>
                </div>

                <div>
                  <a hreflang="he" href="https://www.tomedes.co.il/">
                    עברית
                  </a>
                </div>

                <div>
                  <a hreflang="ja" href="https://jp.tomedes.com">
                    日本語
                  </a>
                </div>

                <div>
                  <a hreflang="ko" href="https://kr.tomedes.com/">
                    한국어
                  </a>
                </div>

                <div>
                  <a hreflang="nb" href="https://no.tomedes.com/">
                    Norsk
                  </a>
                </div>

                <div>
                  <a hreflang="pl" href="https://pl.tomedes.com/">
                    Polski
                  </a>
                </div>

                <div>
                  <a hreflang="ro" href="https://ro.tomedes.com/">
                    Româna
                  </a>
                </div>

                <div>
                  <a hreflang="sv" href="https://sv.tomedes.com/">
                    Svenska
                  </a>
                </div>

                <div>
                  <a hreflang="tr" href="https://tr.tomedes.com/">
                    Türk
                  </a>
                </div>

                <div>
                  <a hreflang="ru" href="https://ru.tomedes.com/">
                    Русский
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
